import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Control } from '../../models/controls/control';
import { OrderingProcessService } from '../../services/ordering-process/ordering-process.service';
import { FormStep } from '../../models/steps/form-step';
import { NgForm } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { StepDelegate } from '../../models/intefaces/step-delegate';
import { OrderService } from '../../services/order/order.service';
import { VerificationService } from '../../services/verification/verification.service';

@Component({
  selector: 'app-steps',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent implements OnInit, AfterViewInit, StepDelegate {
  @Input()
  public forms: Control<any>[][] = [];

  @ViewChild('formElement')
  formElement?: NgForm;

  private readonly isReady = new BehaviorSubject(false);

  get ready(): Observable<boolean> {
    return this.isReady.asObservable();
  }

  constructor(
    private readonly router: Router,
    private readonly orderService: OrderService,
    private readonly verificationService: VerificationService,
    private readonly orderingProcessService: OrderingProcessService
  ) {}

  ngOnInit(): void {
    const step: FormStep = this.orderingProcessService.getCurrentStep();
    this.forms = step.forms;
    this.isReady.next(this.formIsValid());
  }

  private formIsValid(): boolean {
    let isReady = true;
    for (let index = 0; index < this.forms.length && isReady; index++) {
      isReady = this.checkForm(this.forms[index]);
    }
    return isReady;
  }

  private checkForm(form: Control<any>[]): boolean {
    let isReady = true;
    for (let index = 0; index < form.length && isReady; index++) {
      isReady = form[index].isValid();
    }
    return isReady;
  }

  ngAfterViewInit(): void {
    const step: FormStep = this.orderingProcessService.getCurrentStep();
    step.setDelegate(this);
    this.formElement?.statusChanges?.subscribe(() =>
      this.isReady.next(this.isValid())
    );
  }

  private isValid(): boolean {
    return this.formElement?.valid === true;
  }

  onSubmit(): Observable<boolean> {
    if (this.formElement?.form.valid) {
      this.verificationService.addOrder(this.orderService.export());
    }
    return of(this.formElement?.form.valid === true);
  }
}
